import { Route } from '@angular/router';
import { renderOnly } from 'src/app/shared/feature-flags';
import { RenderLibraryComponent } from './library/render-library.component';
import { RenderFlowShellComponent } from './render-flow-shell/render-flow-shell.component';
import { RenderLandingV2Component } from './render-landing-v2/render-landing-v2.component';
import { RENDER_LANDING_URL } from './render-home';
import { RenderCheckoutReturnGuard, RenderJobGuard, RenderSignedInGuard, RenderUploadLeaveGuard } from './render.guards';
import { RenderCheckoutStepComponent } from './steps/render-checkout-step.component';
import { RenderConfirmingStepComponent } from './steps/render-confirming-step.component';
import { RenderDownloadsStepComponent } from './steps/render-downloads-step.component';
import { RenderErrorStepComponent } from './steps/render-error-step.component';
import { RenderPreviewStepComponent } from './steps/render-preview-step.component';
import { RenderProgressStepComponent } from './steps/render-progress-step.component';
import { RenderUploadStepComponent } from './steps/render-upload-step.component';

// /render            the landing (House Lights, docs/render-v2-landing.md; guests and users) —
//                    at the site's root instead on a render-only site (`renderOnly`), where /render
//                    leads there. /render-demo and /render/v2, its addresses while it stood beside
//                    the old landing (removed 2026-10-16), lead to it. /render-demo is a temporary
//                    302 in firebase.json (hosting) — this redirect is its twin for ng serve and
//                    in-app links; drop both once the old link is out of use.
// /render/upload     step 1
// /render/library    "Your library": the user's models, each back to its step
// /render/<step>/:modelId   the job's steps — see RenderFlowStep; the URL always matches the
//                    job's current step (RenderJobGuard), the shell moves it along.
// /success, /cancel  back from Stripe's checkout (RenderCheckoutReturnGuard): into the flow, or
//                    the app's home as before
const LANDING: Route = { pathMatch: 'full', component: RenderLandingV2Component, data: { animation: 'homePageAnimation' } };
const LANDING_ROUTES: Route[] = renderOnly
  ? [{ ...LANDING, path: '' }, { path: 'render', pathMatch: 'full', redirectTo: '/' }]
  : [{ ...LANDING, path: 'render' }];

export const RENDER_ROUTES: Route[] = [
  { path: 'success', canActivate: [RenderCheckoutReturnGuard], children: [] },
  { path: 'cancel', canActivate: [RenderCheckoutReturnGuard], children: [] },
  ...LANDING_ROUTES,
  { path: 'render-demo', pathMatch: 'full', redirectTo: RENDER_LANDING_URL },
  { path: 'render/v2', pathMatch: 'full', redirectTo: RENDER_LANDING_URL },
  {
    path: 'render',
    component: RenderFlowShellComponent,
    canActivate: [RenderSignedInGuard],
    data: { animation: 'homePageAnimation' },
    children: [
      { path: 'upload', component: RenderUploadStepComponent, canDeactivate: [RenderUploadLeaveGuard] },
      { path: 'library', component: RenderLibraryComponent },
      { path: 'processing/:modelId', component: RenderProgressStepComponent, canActivate: [RenderJobGuard], data: { mode: 'processing' } },
      { path: 'preview/:modelId', component: RenderPreviewStepComponent, canActivate: [RenderJobGuard] },
      { path: 'checkout/:modelId', component: RenderCheckoutStepComponent, canActivate: [RenderJobGuard] },
      { path: 'confirming/:modelId', component: RenderConfirmingStepComponent, canActivate: [RenderJobGuard] },
      { path: 'rendering/:modelId', component: RenderProgressStepComponent, canActivate: [RenderJobGuard], data: { mode: 'rendering' } },
      { path: 'downloads/:modelId', component: RenderDownloadsStepComponent, canActivate: [RenderJobGuard] },
      { path: 'error/:modelId', component: RenderErrorStepComponent, canActivate: [RenderJobGuard] },
      { path: '**', redirectTo: 'upload' },
    ],
  },
];
